const STORE = (state, last) => {
  state.last = last;
};
const STORE_MANY = (state, all) => {
  state.all = all;
};
const DESTROY = (state, errors) => {
  state.errors = errors;
};

export default {
  STORE,
  STORE_MANY,
  DESTROY
};
